<template>
  <v-container class="px-10 justify-center">
    <div
      v-if="intervals.length > 1"
      class="pb-3 font-weight-medium"
    >
      Set Interval
    </div>

    <v-btn-toggle
      v-model="idx"
      mandatory
      borderless
      color="primary"
      @change="$emit('dump', {interval_idx: $event})"
    >
      <v-btn
        v-for="(interval, i) in intervals"
        :key="i"
        :disabled="oneTime"
      >
        {{ interval }}
      </v-btn>
    </v-btn-toggle>

    <v-checkbox
      v-model="oneTime"
      :label="oneTimeText || 'Only make this payment once'"
      :ripple="false"
      @change="$emit('dump', {oneTime: $event})"
    />
  </v-container>
</template>

<script>
export default {
  props: {
    subscription: {
      type: Object,
      default: ()=>{return {}}
    },
  },
  data(){
    return {
      idx: 0,
      oneTime: false,
      readonly: true
    }
  },
  computed: {
    intervals(){return this.subscription.intervals || []},
    oneTimeText(){
      return this.subscription.allow_one_time_payment_custom_text
    }
  },
}
</script>